<template>
  <div>
    <Ibox :back="'true'" :titulo="'Configurar cliente'">
      <FormGroup
        cols="4">
        <h2>Usuarios máximos</h2>
        <span>Máximo de usuarios permitidos para el cliente</span>
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <input v-else class="form-control" v-model="cliente.usuarios">
      </FormGroup>
      <FormGroup
        cols="4">
        <h2>Correos de programa</h2>
        <span>Hora envío correo de programacion diaria por hacer</span>
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <v-select 
          v-else
          v-model="cliente.configuracion.hora_correo"
          :clearable=false
          :reduce="habilitado=>habilitado.v"
          :options="options_hora_correo">
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4">
        <h2>Correos de formularios</h2>
        <span>Enviar un correo por cada formulario terminado</span>
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <v-select 
          v-else
          v-model="cliente.un_correo_formulario"
          :clearable=false
          :reduce="habilitado=>habilitado.v"
          :options="[{v:'S',label:'Si'},{v:'N',label:'No'}]">
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4">
        <h2>Organización</h2>
        <span>Usa organización</span>
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <v-select 
          v-else
          v-model="cliente.usa_organizacion"
          :clearable=false
          :reduce="habilitado=>habilitado.v"
          :options="[{v:'S',label:'Si'},{v:'N',label:'No'}]">
        </v-select>
      </FormGroup>
      <b-col cols="12" align="right">
        <b-button v-if="loading" variant="primary"><Loading :size="'1'" :text="'Cargando datos'"/></b-button>
        <b-button v-else-if="editing" variant="primary"><Loading :size="'1'" :text="'Guardando'"/></b-button>
        <b-button v-else variant="primary" v-on:click="editar()">Guardar</b-button>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import {clienteService} from "@/services";
import {utils} from "@/helpers";

export default {
  name: 'Editar', 
  data(){
    return {
      loading: true,
      editing: false,
      cliente: {
        nombre: utils.jd64(this.$route.params.cliente).nombre,
        id_cliente:utils.jd64(this.$route.params.cliente).id_cliente,
        un_correo_formulario:'S',
        configuracion:{
          hora_correo:1
        },
        usa_organizacion:'N',
        usuarios:0
      },
      options_hora_correo:[
        {v:1,label:'01:00'},
        {v:2,label:'02:00'},
        {v:3,label:'03:00'},
        {v:4,label:'04:00'},
        {v:5,label:'05:00'},
        {v:6,label:'06:00'},
        {v:7,label:'07:00'},
        {v:8,label:'08:00'},
        {v:9,label:'09:00'},
        {v:10,label:'10:00'},
        {v:11,label:'11:00'},
        {v:12,label:'12:00'},
        {v:13,label:'13:00'},
        {v:14,label:'14:00'},
        {v:15,label:'15:00'},
        {v:16,label:'16:00'},
        {v:17,label:'17:00'},
        {v:18,label:'18:00'},
        {v:19,label:'19:00'},
        {v:20,label:'20:00'},
        {v:21,label:'21:00'},
        {v:22,label:'22:00'},
        {v:23,label:'23:00'},
        {v:24,label:'24:00'},
      ]
    }
  },
  mounted(){
    this.$store.commit("pagina/setTitulo",'Configuración / Cliente / Configurar ' + this.cliente.nombre);
    this.cargarDatos();
  },
  methods: {
    cargarDatos(){
      this.loading = true;

      clienteService.getClienteConfiguracion(this.cliente).then(respuesta => {
        this.cliente.configuracion = JSON.parse(respuesta.data.configuracion) == null ? {hora_correo:5} : JSON.parse(respuesta.data.configuracion);
        this.cliente.un_correo_formulario = respuesta.data.un_correo_formulario;
        this.cliente.usuarios = respuesta.data.usuarios;
        this.cliente.usa_organizacion = respuesta.data.usa_organizacion;
        this.loading = false;
      });
    },
    editar(){
      this.editing = true;

      clienteService.putClienteConfiguracion(this.cliente).then(respuesta => {
        utils.alerta(respuesta);

        this.editing = false;

        if(respuesta.status == "success"){
          this.$router.go(-1);
        }
      });
    },
  }
}
</script>

<style scoped>
</style>
